import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Card, Col, Divider, Row, Spin, Table, Tag, Typography } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import { apiConfig, labelConfig, staticConfig } from "../teller.config";

const { Text } = Typography;

const InfoRow = ({ label, value, last }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      borderBottom: last ? 0 : "1px solid #F3F4F6",
      minHeight: 40,
    }}
    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F9FAFB")}
    onMouseLeave={(e) =>
      (e.currentTarget.style.backgroundColor = "transparent")
    }
  >
    <div
      style={{
        flex: "0 0 45%",
        padding: "8px 12px",
        backgroundColor: "#F8FAFC",
        borderRight: "1px solid #E5E7EB",
        fontWeight: 600,
        fontSize: 12,
        color: "#374151",
        minHeight: 40,
        display: "flex",
        alignItems: "center",
      }}
    >
      {label}
    </div>
    <div
      style={{
        flex: "0 0 28px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <ArrowRightOutlined style={{ fontSize: 11, color: "#9ca3af" }} />
    </div>
    <div
      style={{
        flex: 1,
        padding: "8px 10px 8px 0",
        fontSize: 12,
        color: "#111827",
        display: "flex",
        alignItems: "center",
      }}
    >
      {value ?? "—"}
    </div>
  </div>
);

const SectionHeader = ({ title }) => (
  <div
    style={{
      fontSize: 11,
      fontWeight: 700,
      color: "#9ca3af",
      letterSpacing: 1,
      textTransform: "uppercase",
      marginBottom: 10,
    }}
  >
    {title}
  </div>
);

const TellerConfigDetail = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const { state } = useLocation();

  const tillId = state?.id;

  const [detail, setDetail] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    console.log(state);

    if (!tillId) {
      navigate("/tlo0100/teller");
      return;
    }
    fetchDetail(tillId);
  }, []);

  const fetchDetail = (id) => {
    const url = `${apiConfig.Tellerconfig}/${id}`;
    BOM.FetchReqAction({ session }, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors?.[0]?.defaultUserMessage || err);
        setIsLoading(false);
      } else {
        setDetail(res);
        setIsLoading(false);
      }
    });
  };

  const boolTag = (val) =>
    val ? <Tag color="green">Yes</Tag> : <Tag color="red">No</Tag>;

  const currencyColumns = [
    { title: "Currency Code", dataIndex: "currencyCode", key: "currencyCode" },
    {
      title: "Authorization Threshold",
      dataIndex: "authThresholdAmount",
      key: "authThresholdAmount",
    },
    {
      title: "Daily Limit",
      dataIndex: "transactionLimit",
      key: "transactionLimit",
    },
  ];

  const currencyData = (detail?.tellerCcyRestrConfData || []).map((c) => ({
    key: c.id,
    currencyCode: c.currencyCode,
    authThresholdAmount: c.authThresholdAmount,
    transactionLimit: c.transactionLimit,
  }));

  const office = detail?.vaultId?.operationId?.office;
  const vaultGl = detail?.vaultId?.vaultGl;

  return (
    <MainLayout isEnableRightSidebar={false}>
      <TopContent
        pageTitle={`Till: ${detail?.description ?? labelConfig.tellerConfigDetail}`}
        pageItems={staticConfig.manageLinkUserToTillTellerItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          {detail && (
            <>
              {/* ── Till Info ─────────────────────────────────────── */}
              <SectionHeader title="Till Information" />
              <Row gutter={24} style={{ marginBottom: 24 }}>
                <Col span={24}>
                  <div
                    style={{
                      border: "1px solid #E5E7EB",
                      borderRadius: 10,
                      overflow: "hidden",
                      marginTop: 10,
                    }}
                  >
                    {/* <div
                      style={{
                        padding: "8px 12px",
                        background:
                          "linear-gradient(135deg, rgba(21,204,174,0.1) 0%, rgba(79,236,160,0.1) 100%)",
                        borderBottom: "1px solid #E5E7EB",
                        fontSize: 11,
                        fontWeight: 700,
                        color: "#0d9488",
                        letterSpacing: 0.5,
                        textTransform: "uppercase",
                      }}
                    >
                      Till Profile
                    </div> */}
                    <InfoRow label="Description" value={detail.description} />
                    <InfoRow
                      label="Allow Denomination Tracking"
                      value={boolTag(detail.allowDenomTracking)}
                    />
                    <InfoRow
                      label="Allow Transaction Reversal"
                      value={boolTag(detail.allowTransactionReversal)}
                    />
                    <InfoRow
                      label="Print Transaction Receipt"
                      value={boolTag(detail.printTransactionReceipt)}
                      last
                    />
                    <InfoRow label="Vault GL" value={vaultGl?.name} />
                    <InfoRow label="GL Code" value={vaultGl?.glCode} last />
                  </div>
                </Col>

                {/* ── Office / Vault Info ─────────────────────────── */}
                {/* <Col span={12}>
                  <div
                    style={{
                      border: "1px solid #E5E7EB",
                      borderRadius: 10,
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        padding: "8px 12px",
                        background:
                          "linear-gradient(135deg, rgba(21,204,174,0.1) 0%, rgba(79,236,160,0.1) 100%)",
                        borderBottom: "1px solid #E5E7EB",
                        fontSize: 11,
                        fontWeight: 700,
                        color: "#0d9488",
                        letterSpacing: 0.5,
                        textTransform: "uppercase",
                      }}
                    >
                      Office & Vault
                    </div>
                    <InfoRow label="Office" value={office?.name} />
                    <InfoRow
                      label="Office Type"
                      value={office?.officeType?.name}
                    />
                    <InfoRow label="Vault GL" value={vaultGl?.name} />
                    <InfoRow label="GL Code" value={vaultGl?.glCode} last />
                  </div>
                </Col> */}
              </Row>

              <Divider style={{ marginTop: 4, marginBottom: 16 }} />

              {/* ── Currency Restrictions ──────────────────────────── */}
              <SectionHeader title="Currency Code Restrictions" />
              <Table
                dataSource={currencyData}
                columns={currencyColumns}
                pagination={false}
                size="small"
                bordered
              />
            </>
          )}
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});

export default connect(mapStateToProps, null)(TellerConfigDetail);
